<template>
    <div class="Register">
        <div class="container">
            <h2 class="page-title">{{'Personalize Your Search' | language}}</h2>
            <p class="page-subtitle">{{'WE assess your needs and send properties right for YOU, just for YOU' | language}}</p>

            <div class="row">
                <div class="col-xs-12">
                    <el-alert title="Email" type="error" v-for="(content, index) of errorContent.email" :key="index"
                        :description="content" show-icon>
                    </el-alert>
                    <el-form :model="register" status-icon :rules="rules" ref="register" label-width="120px" class="demo-ruleForm"
                        @submit.native.prevent
                        :label-position="labelPosition">
                        <div class="row">
                            <el-form-item class="col-sm-4 col-xs-12" label="First Name" prop="first_name">
                                 <el-input v-model="register.first_name" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                            <el-form-item class="col-sm-4 col-xs-12" label="Middle Name" prop="middle_name">
                                <el-input v-model="register.middle_name" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                            <el-form-item class="col-sm-4 col-xs-12" label="Last Name" prop="last_name">
                                <el-input v-model="register.last_name" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                        </div>
                        <h5>Contact Information</h5>
                        <div class="row">
                            <el-form-item class="col-sm-6 col-xs-12" label="Email (Work)" prop="work_email">
                                <el-input v-model="register.work_email" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                             <el-form-item class="col-sm-6 col-xs-12" label="Email (Personal)" prop="personal_email">
                                <el-input v-model="register.personal_email" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                            <el-form-item class="col-sm-6 col-xs-12" label="Phone (Work)" prop="work_phone">
                                <el-input type="number" v-model="register.work_phone" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                             <el-form-item class="col-sm-6 col-xs-12" label="Phone (Personal)" prop="personal_phone">
                                <el-input type="number" v-model="register.personal_phone" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                        </div>
                        <h5>Company Information</h5>
                        <div class="row">
                            <el-form-item class="col-sm-6 col-xs-12" label="Company Name" prop="company">
                                <el-input v-model="register.company" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                            <el-form-item class="col-sm-6 col-xs-12" label="Company Address" prop="company_address">
                                <el-input v-model="register.company_address" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                        </div>
                        <h5>Origin Information</h5>
                        <div class="row">
                            <el-form-item class="col-sm-6 col-xs-12" label="Origin Country" prop="origin_country">
                                <el-input v-model="register.origin_country" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                            <el-form-item class="col-sm-6 col-xs-12" label="Origin City" prop="origin_city">
                                <el-input v-model="register.origin_city" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                        </div>
                        <h5>General Information</h5>
                        <div class="row">
                            <el-form-item class="col-sm-6 col-xs-12" label="Citizenship" prop="citizenship">
                                <el-input v-model="register.citizenship" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                            <el-form-item class="col-sm-6 col-xs-12" label="Primary Language" prop="primary_language">
                                    <el-input v-model="register.primary_language" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                                <el-form-item class="col-sm-6 col-xs-12" label="Counties Live In" prop="countries_live_in">
                                <el-input v-model="register.countries_live_in" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                            <el-form-item class="col-sm-6 col-xs-12" label="Experience Living In Japan" prop="experience_in_japan">
                                    <el-input v-model="register.experience_in_japan" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                            <el-form-item class="col-sm-6 col-xs-12" label="Passport Expiration Date" prop="passport_expiration_date">
                                <el-date-picker
                                    v-model="register.passport_expiration_date"
                                    type="date"
                                    placeholder="Pick a day"
                                    :picker-options="pickerOptions">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item class="col-sm-6 col-xs-12" label="Driver's License Expiration Date" prop="drivers_license_expiration_date">
                                <el-date-picker
                                    v-model="register.drivers_license_expiration_date"
                                    type="date"
                                    placeholder="Pick a day"
                                    :picker-options="pickerOptions">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item class="col-sm-6 col-xs-12" label="Japanese Level" prop="japanese_level">
                                    <el-input v-model="register.japanese_level" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                            <el-form-item class="col-sm-6 col-xs-12" label="Dependent(s) Joining Relocation" prop="dependents_joining_relocation">
                                    <el-input v-model="register.dependents_joining_relocation" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                        </div>
                        <h5>Property Preferences</h5>
                        <div class="row">
                            <el-form-item class="col-sm-6 col-xs-12" label="Area Type" prop="area_type">
                                 <el-select v-model="register.area_type" placeholder="Select">
                                    <el-option
                                    v-for="item in area_types"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item class="col-sm-6 col-xs-12" label="Living Location Desired" prop="desired_location">
                                <el-input type="text" v-model="register.desired_location" autocomplete="off" placeholder="(City, neighborhood, etc.)" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                            <el-form-item class="col-sm-6 col-xs-12" label="Work Location/Address”" prop="work_location">
                                <el-input type="text" v-model="register.work_location" autocomplete="off" placeholder="(City, neighborhood, etc.)" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                             <el-form-item class="col-sm-6 col-xs-12" label="Work Commuting Preferences" prop="work_commuting">
                                 <el-select  v-model="register.work_commuting" placeholder="Select">
                                    <el-option
                                    v-for="item in work_commuting_preferences"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                             <el-form-item class="col-sm-6 col-xs-12" label="Property Type" prop="property_type">
                                <el-select  v-model="register.property_type" placeholder="Select">
                                    <el-option
                                    v-for="item in property_types"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                             <el-form-item class="col-sm-6 col-xs-12" label="Number Of Bedrooms" prop="number_of_bedrooms">
                                <el-select  v-model="register.number_of_bedrooms" placeholder="Select">
                                    <el-option
                                    v-for="item in bedroom_list"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                             <el-form-item class="col-sm-6 col-xs-12" label="Property Size" prop="property_size">
                                <el-input type="number" v-model="register.property_size" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                             <el-form-item class="col-sm-6 col-xs-12" label="Monthly Budget(¥)" prop="monthly_budget">
                                <el-input type="number" v-model="register.monthly_budget" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                             <el-form-item class="col-sm-6 col-xs-12" label="Parking (number of cars)" prop="parking">
                                <el-input type="number" v-model="register.parking" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                             <el-form-item class="col-sm-6 col-xs-12" label="Property Style" prop="property_style">
                                <el-select  v-model="register.property_style" placeholder="Select">
                                    <el-option
                                    v-for="item in property_styles"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                             <el-form-item class="col-sm-6 col-xs-12" label="Desired Move-in Date" prop="move_in_date">
                                <el-date-picker
                                v-model="register.move_in_date"
                                type="date"
                                placeholder="Pick a day"
                                :picker-options="pickerOptions">
                                </el-date-picker>
                            </el-form-item>
                             <el-form-item class="col-sm-6 col-xs-12" label="Expected Duration of Stay" prop="duration_of_stay">
                                <el-input v-model="register.duration_of_stay" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                             <el-form-item class="col-sm-6 col-xs-12" label="Under whose name will the housing contract be under" prop="name_contact_under">
                                <el-select  v-model="register.name_contact_under" placeholder="Select">
                                    <el-option
                                    v-for="item in contact_unders"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                             <el-form-item class="col-sm-6 col-xs-12" label="Furniture" prop="furniture">
                                <el-select  v-model="register.furniture" placeholder="Select">
                                    <el-option
                                    v-for="item in furniture_list"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <h5>Pets</h5>
                        <div class="row">
                            <el-form-item class="col-sm-6 col-xs-12" label="Pet Breed" prop="pet_breed">
                                <el-input  v-model="register.pet_breed" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                            <el-form-item class="col-sm-6 col-xs-12" label="Pet Weight" prop="pet_weight">
                                <el-input  v-model="register.pet_weight" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                        </div>
                        <h5>Additional Information</h5>
                        <p>Please let us know any extra information, preferences or requirements you may have to help us ensure your smooth relocation.</p>
                        <div class="row additional_information">
                            <el-form-item class="col-xs-12" prop="pet_additional_information">
                                <el-input type="textarea" :rows="3" v-model="register.pet_additional_information" autocomplete="off" @keyup.enter.native="submitForm('register')" ></el-input>
                            </el-form-item>
                        </div>
                        <el-form-item>
                            <el-button class="Register__Button" type="primary" @click="submitForm('register')" :loading="loading" >{{'Submit' | language}}</el-button>
                        </el-form-item>
                    </el-form>
                      <el-alert
                        v-if="success"
                        title="Assessment has been sent"
                        type="success"
                        center
                        show-icon>
                    </el-alert>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {
                success:false,
                labelPosition: 'top',
                register: {
                    first_name: '',
                    middle_name:'',
                    last_name:'',
                    work_email:'',
                    personal_email:'',
                    work_phone:'',
                    personal_phone:'',
                    company: '',
                    company_address:'',
                    origin_country:'',
                    origin_city:'',
                    citizenship:'',
                    primary_language:'',
                    countries_live_in:'',
                    experience_in_japan:'',
                    passport_expiration_date:'',
                    drivers_license_expiration_date:'',
                    japanese_level:'',
                    dependents_joining_relocation:'',
                    area_type:'',
                    desired_location:'',
                    work_location:'',
                    work_commuting:'',
                    property_type:'',
                    number_of_bedrooms:'',
                    property_size:'',
                    monthly_budget:'',
                    parking:'',
                    property_style:'',
                    move_in_date:'',
                    duration_of_stay:'',
                    name_contact_under:'',
                    furniture:'',
                    pet_breed:'',
                    pet_weight:'',
                    pet_additional_information:''
                },
                errorContent: '',
                loading: false,
                area_types:[
                    'Downtown',
                    'Suburb',
                    'Rural'
                ],
                work_commuting_preferences:[
                    'Train',
                    'Subway',
                    'Bus',
                    'Car',
                    'walk'
                ],
                property_types:[
                    'House',
                    'Apartment',
                    'No Preference'
                ],
                bedroom_list:[
                    '1+',
                    '2+',
                    '3+',
                    '4+'
                ],
                property_styles:[
                    'Japanese',
                    'Western'
                ],
                contact_unders:[
                    'Individual Lease',
                    'Corporate Lease'
                ],
                furniture_list:[
                    'Purchase',
                    'Lease',
                    'Will Ship'
                ],
                rules: {

                    first_name:[
                        {required: true, message: 'Please input your name', trigger:'blur'}
                    ],
                    personal_email:[
                        { required: true, message: 'Please input your personal email address', trigger: 'blur' },
                        { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
                    ],
                    personal_phone:[
                        {required:true,message:'Please input your personal phone number', trigger:'blur'}
                    ]
                },
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now();
                    },
                    shortcuts: [{
                        text: 'Today',
                        onClick(picker) {
                        picker.$emit('pick', new Date());
                        }
                    }, {
                        text: 'A week later',
                        onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                        }
                    }, {
                        text: '30 days later',
                        onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', date);
                        }
                    }]
                },
            };
        },
        methods: {
            submitForm(formName) {
                event.preventDefault()
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.errorContent = ''
                        this.success = false
                        const promise =  this.$store.dispatch('general/sendAnalysisForm',this.register)
                        promise
                        .then(() => {
                            this.success = true
                        })
                        .catch(error => {
                            this.errorContent = error
                        })
                        .finally(()=>{
                            this.loading = false
                        })
                    } else {
                        return false
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        },
        head: {
            title: function() {
                return {
                    inner: 'Needs Assessment'
                }
            },
            meta: [
                { name: 'title', content: 'Create an account with Japan Home Finder' },
                { name: 'keywords', content: 'japan home finder, japan realestate, apartment, house, for rent, for lease' },
                { name: 'description', content: 'Making your Japan home search easier' }
            ]
        }
    }
</script>

<style lang="scss" scoped>
    .Register {
        padding: 1em 0 3em 0;

        .page-title {
            margin-bottom: 0;
        }

        .page-subtitle {
            text-align: center;
            font-size: 1.1em;
            color: $alternate-color;
        }

        form {
            max-width: 800px;
            margin: 0 auto;
            padding-top: 1em;

            .el-form-item {
                &.is-error {
                    margin-bottom: 1em!important;
                }

                .el-select, .el-date-editor {
                    width: 100%;
                }
            }

            h5 {
                margin: 1.5em 0 .5em 0;
            }

            .row {
                border-bottom: 1px solid rgba($alternate-color, .1);
                padding-bottom: 2em;
            }
        }

        h2 {
            text-align: center;
        }

        &__Button {
            margin-top: 2em;
        }

        @media (max-width: 767px) {
        }
    }
</style>